import React, {Component} from 'react'
import Base from '../BaseComponent'
import Content from '../Content'
import {TweenMax} from 'gsap'

import {
  Link
} from 'react-router-dom';

class Banners extends Component {

  componentDidMount()
  {
    let twitterWidth = this.refs.twitterContent.getBoundingClientRect().width;
    this.refs.twitterBanner.style.width=(twitterWidth*3) + 'px';

    let instaWidth = this.refs.instagramContent.getBoundingClientRect();
    this.refs.instagramBanner.style.width=(instaWidth.width*3) + 'px';

    let fbWidth = this.refs.facebookContent.getBoundingClientRect().width;
    this.refs.facebookBanner.style.width=(fbWidth*3) + 'px';

  }

  render () {

    return (
      <div className="Banners">

                      <div className="Banner  Banner--twitter" ref="twitterBanner">
                        <div className="Banner-container">
                          <div className="Banner-content">
                          <a href={this.props.entry.sections[3].twitterLink} target="_blank">

                              <ul ref="twitterContent">
                                <li>
                                  <Content>
                                    <h3>{this.props.entry.sections[3].twitterText}</h3>
                                  </Content>
                                </li>
                              </ul>


                              <ul className="Banner-2">

                                <li>
                                  <Content>
                                    <h3>{this.props.entry.sections[3].twitterText}</h3>
                                  </Content>
                                </li>
                                </ul>

                            <ul className="Banner-2">

                              <li>
                                <Content>
                                  <h3>{this.props.entry.sections[3].twitterText}</h3>
                                </Content>
                              </li>


                            </ul>

                           </a>

                          </div>
                        </div>
                      </div>

                      <div className="Banner  Banner--instagram Banner--right"  ref="instagramBanner">
                        <div className="Banner-container">
                          <div className="Banner-content">

                           <a href={this.props.entry.sections[3].instagramLink} target="_blank">

                              <ul ref="instagramContent">

                                <li>
                                  <Content>
                                    <h3>{this.props.entry.sections[3].instagramText}</h3>
                                  </Content>
                                </li>


                              </ul>

                              <ul>

                                <li>
                                  <Content>
                                    <h3>{this.props.entry.sections[3].instagramText}</h3>
                                  </Content>
                                </li>


                              </ul>
                              <ul>

                                <li>
                                  <Content>
                                    <h3>{this.props.entry.sections[3].instagramText}</h3>
                                  </Content>
                                </li>


                              </ul>
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="Banner  Banner--facebook" ref="facebookBanner">
                        <div className="Banner-container">
                          <div className="Banner-content">

                            <a href={this.props.entry.sections[3].facebookLink} target="_blank">

                              <ul ref="facebookContent">

                                <li>
                                  <Content>
                                    <h3>{this.props.entry.sections[3].facebookText}</h3>
                                  </Content>
                                </li>


                              </ul>
                              <ul>

                                <li>
                                  <Content>
                                    <h3>{this.props.entry.sections[3].facebookText}</h3>
                                  </Content>
                                </li>


                              </ul>
                              <ul>

                                <li>
                                  <Content>
                                    <h3>{this.props.entry.sections[3].facebookText}</h3>
                                  </Content>
                                </li>


                              </ul>
                            </a>
                          </div>
                        </div>
                      </div>

                    </div>
    )
  }
}

export default Banners



// WEBPACK FOOTER //
// ./src/js/components/Banners/Banners.jsx